module.exports = __webpack_public_path__ + "img/testbg.f2de1d51.png";